// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-title{font-size:16px;font-weight:400;padding:5px 15px}
`, "",{"version":3,"sources":["webpack://./src/processes/massive_actions/CensusCooler/components/VeBoxAutoSuggest/styles/styles.scss"],"names":[],"mappings":"AAAA,aACE,cAAe,CACf,eAAgB,CAChB,gBAAiB","sourcesContent":[".group-title {\n  font-size: 16px;\n  font-weight: 400;\n  padding: 5px 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
